export type SocialLink = {
  label: string
  href: string
}

/** @deprecated Use footerSocialLinks for the marketing footer. */
export const socialLinks: SocialLink[] = [
  { label: 'X', href: 'https://x.com/PodiumMarketsAI' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/podiummarkets' },
]

export type SocialPlatform = 'x' | 'instagram' | 'tiktok'

export const footerSocialLinks: {
  platform: SocialPlatform
  href: string
  label: string
}[] = [
  { platform: 'x', href: 'https://x.com/PodiumMarketsAI', label: 'X' },
  {
    platform: 'instagram',
    href: 'https://www.instagram.com/podiummarketsai/',
    label: 'Instagram',
  },
  {
    platform: 'tiktok',
    href: 'https://www.tiktok.com/@podiummarketsai',
    label: 'TikTok',
  },
]

export type NavLink = {
  label: string
  href: string
}

/** Consent-banner open token — dispatch `consent:open` to re-show the cookie banner. Retained for reuse; not currently linked in the footer. */
export const FOOTER_MANAGE_COOKIES_HREF = '#manage-cookies'

export type NavSection = {
  title: string
  links: NavLink[]
}

export const featureLinks: NavLink[] = [
  { label: 'Meet Ivy', href: '/' },
  { label: 'Portfolio Intelligence', href: '/features/portfolio-intelligence' },
  { label: 'Market Intelligence', href: '/features/market-intelligence' },
  { label: 'Research Intelligence', href: '/features/research-intelligence' },
]

export const headerNavLinks: NavLink[] = [
  { label: 'Pricing', href: '/pricing' },
  { label: 'Founding Traders', href: '/founding-traders' },
  { label: 'Support', href: '/support' },
]

export type MobileNavSection = {
  id: string
  label: string
  links: NavLink[]
}

export const mobileNavSections: MobileNavSection[] = [
  { id: 'features', label: 'Features', links: featureLinks },
  ...headerNavLinks.map((link) => ({
    id: link.href.replace(/^\//, ''),
    label: link.label,
    links: [link],
  })),
]

export const footerSections: NavSection[] = [
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Blog', href: '/blogs' },
      { label: 'Newsroom', href: '/newsroom' },
      { label: 'Support', href: '/support' },
      { label: 'Founding Traders', href: '/founding-traders' },
    ],
  },
  {
    title: 'Features',
    links: featureLinks,
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', href: '/legal/terms' },
      { label: 'Privacy Policy', href: '/legal/privacy' },
      { label: 'Responsible Use Policy', href: '/legal/responsible-use' },
      { label: 'Platform Disclaimer & Disclosure', href: '/legal/platform-disclaimer' },
    ],
  },
]

export function getAppUrl(path: string): string {
  const base =
    import.meta.env.VITE_APP_BASE_URL?.replace(/\/$/, '') || 'https://app.podiummarkets.ai'
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}
